import React from "react";
import Lottie from "react-lottie";
import { sadfoxSettings } from "../../views/calificacion/Styles";

export const SadFox = () => {
  return <Lottie options={sadfoxSettings} width={400} />;
};
